export const RESET = 'RESET';
export const CALCULATE_ODDS = 'CALCULATE_ODDS';
export const ADD_CARD_TO_BOARD = 'ADD_CARD_TO_BOARD';
export const UPDATE_ACTIVE_FIELD = 'UPDATE_ACTIVE_FIELD';
export const TOGGLE_CARD_ACTIVE = 'TOGGLE_CARD_ACTIVE';
export const REMOVE_CARD = 'REMOVE_CARD';
export const TOGGLE_HINT = 'TOGGLE_HINT';
export const CLOSE_HINT = 'CLOSE_HINT';
export const SHOW_HINT = 'SHOW_HINT';
export const SET_RULES = 'SET_RULES';
export const SET_PLAYERS_COUNT = 'SET_PLAYERS_COUNT';
export const SET_ACTIVE_FIELD = 'SET_ACTIVE_FIELD';
export const SET_CHOSEN_CARD = 'SET_CHOSEN_CARD';
export const SET_WINNER = 'SET_WINNER';
export const GET_WINNER_HAND = 'GET_WINNER_HAND';
export const SET_BOARD_PLAYERS = 'SET_BOARD_PLAYERS';
export const SET_BOARD_CAROUSEL = 'SET_BOARD_CAROUSEL';